import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "bool_yes_no",
    standalone: false
})
export class BoolPipe implements PipeTransform {
    transform(rawBool: boolean): string {
        let resp = '';
    if (rawBool) {
        resp = 'Yes';
    } else {
        resp = 'No';
    }
    return resp;
    }
}